import React, { Component } from 'react'
import {StyledCard, CardsProfile, CompanyBody, CardsCompany} from '../styled/StyledCard'
import {ItemSecondary,Title,SubTitle, CardsVacancy, ItemThird,Img }  from '../styled/StyledCard'
// import imgs from '../img/bg-header-desktop.svg' 

export class Cards extends Component {
    
    render() {
      const {company,photecompany, profile, time, workingDay, site, skills, id} = this.props.jobs;
      let skillOne, skillTwo, skillThree, skillFoor, skillFive;
      [skillOne, skillTwo, skillThree, skillFoor, skillFive] = skills
    return (
      <div>
          {/* <img src={imgs}/> */}
          <StyledCard>
              <CardsProfile>
                  <Img src={photecompany} alt="logo"/>
              </CardsProfile>
              <CardsCompany>
                  <CompanyBody>
                      <Title>{company}</Title>
                  </CompanyBody>
                  <SubTitle id={id}>{profile} </SubTitle>
                  <CompanyBody>
                      <ItemSecondary>{time}</ItemSecondary>
                      <ItemSecondary>{workingDay}</ItemSecondary>
                      <ItemSecondary>{site}</ItemSecondary>
                  </CompanyBody>
              </CardsCompany>
              <CardsVacancy>
                  <ItemThird>{skillOne}</ItemThird>
                  <ItemThird>{skillTwo}</ItemThird>
                  <ItemThird>{skillThree}</ItemThird>
                  <ItemThird>{skillFoor}</ItemThird>
                  <ItemThird>{skillFive || '...'}</ItemThird>
              </CardsVacancy>
          </StyledCard>      
      </div>
    )
  }
}

export default Cards
